import React, { useEffect, useState } from 'react';
import styles from './CustomSpinner.module.scss';
import logo from '../assets/logo_chain.svg';
import { Spinner } from 'react-bootstrap';
import { Text } from './typography';
import classNames from 'classnames';

const FADE_DURATION = 1000;

export default function CustomSpinner({ text, show = true, className }) {
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) {
      setShouldRender(true);
    } else if (shouldRender) {
      const timeout = setTimeout(() => setShouldRender(false), FADE_DURATION);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div className={classNames(`${styles.spinnerOverlay}`, className)}>
      <div className={styles.spinnerContainer}>
        <Spinner className={styles.spinner} animation="border" />
        <img alt="loading icon" className={styles.logo} src={logo} />
      </div>
      <Text className={styles.text}>{text}</Text>
    </div>
  );
}
